<div class="main-container flex-column">
    <div class="flex-item flex-row-title text-center">
        <div class="flex-column text-center">
            <div class="title">
                {{ _i18n._9727_COMMIT_FOCUS_CONTAINERS | translate }}
            </div>
            <br />
        </div>
    </div>
    <div class="flex-item mb-4 messageBox">
        <div
            class="focus-category-container"
            *ngIf="existingFocusList().length > 0"
        >
            <p class="category-title">
                {{ _i18n._9729_ACTIVE_FOCUS_ES_ | translate }}
            </p>
            <div class="focus-list">
                <div
                    *ngFor="let item of existingFocusList()"
                    [ngClass]="{ disabled: _isDisabled(item) }"
                >
                    <div class="radio-button-container">
                        <cmps-radio
                            [name]="item.ID"
                            [checked]="_isChecked(item)"
                            [disabled]="_isDisabled(item)"
                            (change)="_onSelectedFocusChange(item)"
                        >
                        </cmps-radio>
                    </div>

                    <div class="focus-container">
                        <div class="container-header">
                            <p>
                                <strong
                                    >{{ _i18n._9422_BEHAVIOUR_ | translate }}
                                    {{ item.BehaviourText }}</strong
                                >
                            </p>
                            <p *ngIf="!_isDisabled(item)">
                                {{ _i18n._9728_LINK_OBSERVATION | translate }}
                            </p>
                        </div>
                        <div class="container-body">
                            <p class="mb-0">
                                <strong
                                    >{{
                                        _i18n._9423_SUB_BEHAVIOUR_ | translate
                                    }}
                                    {{ item.SubBehaviourText }}</strong
                                >
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="focus-category-container"
            *ngIf="newFocusList().length > 0"
        >
            <p class="category-title">
                {{ _i18n._9730_NEW_FOCUS_ES_ | translate }}
            </p>
            <div class="focus-list">
                <div *ngFor="let item of newFocusList()">
                    <div class="radio-button-container">
                        <cmps-radio
                            [name]="item.ID"
                            [checked]="_isChecked(item)"
                            [disabled]="_isDisabled(item)"
                            (change)="_onSelectedFocusChange(item)"
                        >
                        </cmps-radio>
                    </div>

                    <div class="focus-container">
                        <div class="container-header">
                            <p>
                                {{ _i18n._9422_BEHAVIOUR_ | translate }}
                                {{ item.BehaviourText }}
                            </p>
                            <p>
                                {{ _i18n._9731_DRAFT_COMMITMENT | translate }}
                            </p>
                        </div>
                        <div class="container-body">
                            <p class="mb-0">
                                <strong
                                    >{{
                                        _i18n._9423_SUB_BEHAVIOUR_ | translate
                                    }}
                                    {{ item.SubBehaviourText }}</strong
                                >
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="flex-row">
        <div class="flex-item">
            <div class="flex-buttons-container text-center">
                <button
                    type="button"
                    class="btn btn-outlined"
                    (click)="_dialogRef.close({ option: _dialogResult.CANCEL })"
                >
                    {{ _i18n._121_CANCEL | translate }}
                </button>
                <button
                    type="button"
                    class="btn btn-outlined"
                    [disabled]="selectedBehaviour == null"
                    (click)="_publish()"
                >
                    {{ _i18n._9415_PUBLISH | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
